import { useState, useEffect, useRef } from "react";
export default function HeroSection() {
  const ref = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section ref={ref} style={{
    backgroundColor: "rgb(0, 0, 0)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(26, 26, 26)",
    fontFamily: "Inter, system-ui, -apple-system, sans-serif",
    paddingTop: "96px",
    paddingBottom: "96px",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    position: "relative",
    overflow: "hidden",
    minHeight: "918px"
  }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500;600&family=Inter:wght@300;400;600&display=swap');`}</style>

      <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684748/img/hero_orthosis.png" alt="A middle-aged patient wearing a modern black leg orthosis brace walking confidently down a sunlit residential street" className="w-full h-auto" style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "center",
      opacity: 0.65,
      maxWidth: "100%",
      overflow: "clip"
    }} />

      <div className="absolute inset-0" style={{
      backgroundImage: "linear-gradient(to top, oklab(0 0 0 / 0.8) 0%, oklab(0 0 0 / 0.55) 50%, oklab(0 0 0 / 0.45) 100%)",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    }} />

      <div className="page-container" style={{
      position: "relative",
      zIndex: 10,
      width: "100%"
    }}>
        <div className={`flex flex-col items-center text-center transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h1 style={{
          color: "rgb(255, 255, 255)",
          fontFamily: '"Cormorant Garamond", Georgia, serif',
          fontSize: "clamp(36px, 5vw, 60px)",
          fontWeight: "400",
          lineHeight: "1.1",
          letterSpacing: "-1.5px",
          border: "0px solid rgb(255, 255, 255)",
          textAlign: "center",
          maxWidth: "750px",
          marginBottom: "24px"
        }}>
            Enhancing everyday lives with medical equipment solutions.
          </h1>

          <p style={{
          color: "rgba(255, 255, 255, 0.85)",
          fontFamily: "Inter, system-ui, -apple-system, sans-serif",
          fontSize: "clamp(18px, 2vw, 24px)",
          fontWeight: "300",
          lineHeight: "39px",
          border: "0px solid rgba(255, 255, 255, 0.85)",
          textAlign: "center",
          maxWidth: "600px",
          marginBottom: "40px"
        }}>
            Specialized durable medical equipment delivered with clinical precision and human compassion.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="#contact" style={{
            color: "rgb(255, 255, 255)",
            fontFamily: "Inter, system-ui, -apple-system, sans-serif",
            fontSize: "14px",
            fontWeight: "600",
            lineHeight: "20px",
            letterSpacing: "0.7px",
            backgroundColor: "rgb(229, 31, 38)",
            border: "0px solid rgb(255, 255, 255)",
            padding: "16px 32px",
            textTransform: "uppercase",
            textAlign: "center",
            display: "inline-block",
            cursor: "pointer",
            transition: "opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1), transform 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
            textDecoration: "none"
          }} onMouseEnter={e => {
            (e.currentTarget as HTMLAnchorElement).style.opacity = "0.85";
            (e.currentTarget as HTMLAnchorElement).style.transform = "scale(1.03)";
          }} onMouseLeave={e => {
            (e.currentTarget as HTMLAnchorElement).style.opacity = "1";
            (e.currentTarget as HTMLAnchorElement).style.transform = "scale(1)";
          }}>
              CONTACT US
            </a>

            <a href="tel:6317403058" style={{
            color: "rgb(255, 255, 255)",
            fontFamily: "Inter, system-ui, -apple-system, sans-serif",
            fontSize: "14px",
            fontWeight: "600",
            lineHeight: "20px",
            letterSpacing: "0.7px",
            border: "1px solid rgb(255, 255, 255)",
            padding: "16px 32px",
            textTransform: "uppercase",
            textAlign: "center",
            display: "inline-block",
            backgroundColor: "transparent",
            cursor: "pointer",
            transition: "background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), transform 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
            textDecoration: "none"
          }} onMouseEnter={e => {
            (e.currentTarget as HTMLAnchorElement).style.backgroundColor = "rgba(255, 255, 255, 0.1)";
            (e.currentTarget as HTMLAnchorElement).style.transform = "scale(1.03)";
          }} onMouseLeave={e => {
            (e.currentTarget as HTMLAnchorElement).style.backgroundColor = "transparent";
            (e.currentTarget as HTMLAnchorElement).style.transform = "scale(1)";
          }}>
              CALL 631-740-3058
            </a>
          </div>
        </div>
      </div>
    </section>;
}